export default __webpack_public_path__ + "static/media/clothes2.23d60764.png";